if ($('.js-instagramSlider').length > 0) {
	let instagramSlider = null;

	function instagramSliderInit(){
		instagramSlider = new Swiper($('.js-instagramSlider .swiper-container'), {
			slidesPerView: 'auto',
			spaceBetween: 10,
			slidesOffsetBefore: 20,
			slidesOffsetAfter: 20,
			watchOverflow: true,
			breakpointsInverse: true,

			breakpoints: {
				768: {
					slidesOffsetBefore: 30,
					slidesOffsetAfter: 30
				},
				1180: {
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0,
					spaceBetween: 30
				}
			}
		});
	}

	instagramSliderInit();
}
